import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { PageHeader, CustomPanel, CustomCheckbox } from '../../../../components'
import Modal from './ModalEquipeSeparacao'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as EquipeHttp from '../../../../services/api/https/picking/picking-team.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_TEAMS: 'Adquirindo equipes',
}

const INITIAL_STATE = {
  equipes: [],
  modal: {
    show: false,
    data: {
      id: null,
      name: '',
      actived: true,
      tp_id: 0,
    },
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function EquipeSeparacao({ dispatch, history, selectedTp }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_TEAMS }))
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_TEAMS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getEquipes(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const getEquipes = selectedTp => {
    EquipeHttp.getEquipes(selectedTp)
      .then(equipes =>
        setState(prevState => ({
          ...prevState,
          equipes: equipes,
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const onBtnNovo = selectedTpID => {
    if (selectedTp !== 0)
      setState(prevState => ({
        ...prevState,
        modal: { show: true, data: { id: null, name: '', actived: true, tp_id: selectedTpID } },
      }))
    else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
  }

  const onModalClose = () => {
    setState(prevState => ({
      ...prevState,
      modal: { show: false, data: { ...INITIAL_STATE.modal.data } },
    }))
  }

  const onModalSave = equipe => {
    setState(prevState => {
      const index = prevState.equipes.findIndex(l => l.id === equipe.id)
      if (index !== -1) prevState.equipes[index] = equipe
      else prevState.equipes.push(equipe)
      prevState.modal = { show: false, data: { ...INITIAL_STATE.modal.data } }
      return { ...prevState }
    })
  }

  const onRowClicked = equipe => {
    setState(prevState => ({
      ...prevState,
      modal: {
        show: true,
        data: { id: equipe.id, name: equipe.name, actived: equipe.actived, tp_id: equipe.tp_id },
      },
    }))
  }

  return (
    <div>
      <PageHeader>4.2 - Equipes de Separação</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => onBtnNovo(selectedTp)} onVoltar={history.goBack}>
          <DataTable
            value={state.equipes}
            selectionMode="single"
            onSelectionChange={e => onRowClicked(e.value)}
            emptyMessage="Não existe Equipe cadastrada"
          >
            <Column field="name" header="Equipes de Separação" />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered()}
              body={rowData => <CustomCheckbox disabled checked={rowData.actived} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <Modal
        show={state.modal.show}
        onModalClose={onModalClose}
        onModalSave={onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(EquipeSeparacao))
